module.exports = __webpack_public_path__ + "static/img/deng2.5b1e93c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongqiu/deng2.png
// module id = DEx0
// module chunks = 1